import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseElement } from '../base-element';
import { FormEvent } from '../../../crud/form/form-event.enum';

@Component({
  selector: 'radio-base',
  templateUrl: './base-radio.component.html',
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BaseRadioComponent),
    multi: true
  } ]
})
export class BaseRadioComponent extends BaseElement<string> implements OnInit {

  @Input() value: any;
  @Input() placeholder: string;
  @Input() id: string;

  error = '';

  ngOnInit(): void {
    if (this.label && this.isRequired) {
      this.label += ' *';
    }
    this.channel.subscribe((event: FormEvent) => {
      if (event === FormEvent.SUBMIT) {
        if (this.form.controls[this.formControlName].invalid) {
          this.toggleInvalidClass(true);
          this.renderErrors();
        } else {
          this.toggleInvalidClass(false);
        }
      }
    });

    this.id = this.formControlName + '-' + this.value;
  }

  onChange(): void {
    this.error = '';
    this.toggleInvalidClass(false);
    if (this.change) {
      this.change.emit(this.form.controls[this.formControlName].value);
    }
  }

  protected toggleInvalidClass(flag: boolean): void {
    this.customClass = Object.assign(this.customClass, { 'is-invalid': flag });
  }

  protected renderErrors(): void {
    this.error = '';
    if (!this.errorMessages) {
      return;
    }

    if (typeof this.errorMessages === 'string') {
      this.error = this.errorMessages;
    } else {
      const errors = this.form.controls[this.formControlName].errors;
      for (const validator of Object.keys(errors)) {
        if (errors[validator]) {
          this.error += this.errorMessages[validator] + '<br />';
        }
      }
    }
  }
}
